const validateRequired = value => (value ? null : "Required");

const validateRequiredForSpouse = (values, errors) => {
  if (values.SpouseName) {
    if (!values.SpouseHeight) {
      errors.SpouseHeight = "Required";
    }
    if (!values.SpouseWeight) {
      errors.SpouseWeight = "Required";
    }
  }
};

const validateRequiredForChild = (values, errors, child) => {
  if (values[`${child}ChildName`]) {
    if (!values[`${child}ChildHeight`]) {
      errors[`${child}ChildHeight`] = "Required";
    }
    if (!values[`${child}ChildWeight`]) {
      errors[`${child}ChildWeight`] = "Required";
    }
  }
};

const validateRequiredForHabits = (values, errors, member) => {
  const prefix = member !== "Emp" ? "Emp" : "";

  if (values[`${member}Smoke`] === "Yes" && !values[`${member}SmokeQuantity`]) {
    errors[`${member}SmokeQuantity`] = "Required";
  }
  if (
    values[`${member}Smoke`] === "Yes" &&
    !values[`${member}SmokeNoOfYears`]
  ) {
    errors[`${member}SmokeNoOfYears`] = "Required";
  }

  if (
    values[`${member}${prefix}ConsumeAlcohol`] === "Yes" &&
    !values[`${member}AlcoholType`]
  ) {
    errors[`${member}AlcoholType`] = "Required";
  }

  if (
    values[`${member}${prefix}ConsumeAlcohol`] === "Yes" &&
    !values[`${member}AlcoholQuantity`]
  ) {
    errors[`${member}AlcoholQuantity`] = "Required";
  }

  if (
    values[`${member}Adventure`] === "Yes" &&
    !values[`${member}AdventureInfo`]
  ) {
    errors[`${member}AdventureInfo`] = "Required";
  }
};

const validateRequiredForFamilyHistory = (values, errors) => {
  if (values.EmpFamilyHistory === "Yes") {
    if (!values.FamilyRelationship1) {
      errors.FamilyRelationship1 = "Required";
    }
  }
};

const validateForm = values => {
  const errors = {};

  validateRequiredForSpouse(values, errors);
  validateRequiredForChild(values, errors, "First");
  validateRequiredForChild(values, errors, "Second");
  validateRequiredForChild(values, errors, "Third");
  validateRequiredForHabits(values, errors, "Emp");
  validateRequiredForHabits(values, errors, "Sp");
  validateRequiredForHabits(values, errors, "Ch");
  validateRequiredForFamilyHistory(values, errors);

  return errors;
};

export { validateForm, validateRequired };



// WEBPACK FOOTER //
// ./components/employee/hdf-forms/Tokiomarine/validation.js